import { render, staticRenderFns } from "./GroupSurveyEditor.vue?vue&type=template&id=16be93a6"
import script from "./GroupSurveyEditor.vue?vue&type=script&lang=ts"
export * from "./GroupSurveyEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports